// Route definitions - import paths only, lazy-loaded in PageContent
const routes = [
	{
		path: 'automation',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Automation'); return { Component }; },
	},
	{
		path: 'automation/:automationId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Automation'); return { Component }; },
	},
	{
		path: 'account',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Account'); return { Component }; },
	},
	{
		path: 'terms-of-service',
		lazy: async () => { const { default: Component } = await import('../pages/protected/InternalTermsOfService'); return { Component }; },
	},
	{
		path: 'account/payment',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Checkout'); return { Component }; },
	},
	{
		path: 'organizations',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Organizations'); return { Component }; },
	},
	{
		path: 'organizations/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleOrganization'); return { Component }; },
	},
	{
		path: 'organization-stats',
		lazy: async () => { const { default: Component } = await import('../pages/protected/OrganizationStats'); return { Component }; },
	},
	{
		path: 'organization-stats/:organizationId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/OrganizationStats'); return { Component }; },
	},
	{
		path: 'help-center',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Documentation'); return { Component }; },
	},
	{
		path: 'help-center/documentation',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Documentation'); return { Component }; },
	},
	{
		path: 'help-center/tickets',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Documentation'); return { Component }; },
	},
	{
		path: 'help-center/tickets/new',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Documentation'); return { Component }; },
	},
	{
		path: 'help-center/tickets/:ticketId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Documentation'); return { Component }; },
	},
	{
		path: 'help-center/ai-assistant',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Documentation'); return { Component }; },
	},
	{
		path: 'dashboard',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Dashboard'); return { Component }; },
	},
	{
		path: 'settings',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Settings'); return { Component }; },
	},
	{
		path: 'resources',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Resources'); return { Component }; },
	},
	{
		path: 'resources/:resourceId/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/EditResource'); return { Component }; },
	},
	{
		path: 'profile',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Profile'); return { Component }; },
	},
	{
		path: 'schedule/workout/:scheduleEventId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Workout'); return { Component }; },
	},
	{
		path: 'schedule/workout',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Workout'); return { Component }; },
	},
	{
		path: 'schedule/completed/:scheduleEventId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleCompletedWorkout'); return { Component }; },
	},
	{
		path: 'leaderboard',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Leaderboard'); return { Component }; },
	},
	{
		path: 'reporting',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Reporting'); return { Component }; },
	},
	{
		path: 'reporting/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Reporting'); return { Component }; },
	},
	{
		path: 'assessments',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Assessments'); return { Component }; },
	},
	{
		path: 'assessments/:assessmentId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Assessments'); return { Component }; },
	},
	{
		path: 'assessmentItems',
		lazy: async () => { const { default: Component } = await import('../pages/protected/AssessmentItems'); return { Component }; },
	},
	{
		path: 'assessmentItems/:assessmentId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/AssessmentItems'); return { Component }; },
	},
	{
		path: 'questionnaires',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Questionnaire'); return { Component }; },
	},
	{
		path: 'questionnaires/:questionnaireId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Questionnaire'); return { Component }; },
	},
	{
		path: 'questionnaires/:questionnaireId/responses',
		lazy: async () => { const { default: Component } = await import('../pages/protected/QuestionnaireResponses'); return { Component }; },
	},
	{
		path: 'questionnaires/:questionnaireId/responses/graph/:userId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/QuestionnaireResponsesGraph'); return { Component }; },
	},
	{
		path: 'questionnaires/:questionnaireId/responses/:questionnaireResponseId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/QuestionnaireResponses'); return { Component }; },
	},
	{
		path: 'athlete',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Athletes'); return { Component }; },
	},
	{
		path: 'users/',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Users'); return { Component }; },
	},
	{
		path: 'users/:userId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleUser'); return { Component }; },
	},
	{
		path: 'users/:userId/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/EditUser'); return { Component }; },
	},
	{
		path: 'users/:userId/edit/qr',
		lazy: async () => { const { default: Component } = await import('../pages/protected/QRCodeGenerator'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/edit/:userId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/EditAthlete'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/EditAthlete'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/schedule-editor',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleEditor'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/schedule-editor/:workoutDate',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleWorkoutSelector'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/schedule-editor/:workoutDate/workouts/:workoutId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleWorkoutConstructor'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/schedule-editor/:workoutDate/event/:scheduleEventId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleWorkoutConstructor'); return { Component }; },
	},
	{
		path: 'in-person-scheduling',
		lazy: async () => { const { default: Component } = await import('../pages/protected/InPersonScheduling'); return { Component }; },
	},
	{
		path: 'facility-management',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/dashboard',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/calendar',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/my-bookings',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/bookings',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/locations',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/blocks',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/coach-availability',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/coaches',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/activities',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/booking-rules',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/locations/new',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'facility-management/locations/:locationId/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FacilityManagement'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/assessments',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CompletedAssessments'); return { Component }; },
	},
	{
		path: 'athletes/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/AthletePage'); return { Component }; },
	},
	{
		path: 'completed-assessments/:assessmentId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CompletedAssessments'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/assessments/:completedAssessmentId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleCompletedAssessment'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/assessments/new',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ChooseInputAssessment'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/assessments/:assessmentId/input',
		lazy: async () => { const { default: Component } = await import('../pages/protected/InputAssessment'); return { Component }; },
	},
	{
		path: 'athlete/:athleteId/assessments/:assessmentId/input/:assessmentResponseId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/InputAssessment'); return { Component }; },
	},
	{
		path: 'coach',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Coaches'); return { Component }; },
	},
	{
		path: 'coach/:coachId/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/EditCoach'); return { Component }; },
	},
	{
		path: 'coach/:coachId/edit/:userId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/EditCoach'); return { Component }; },
	},
	{
		path: 'schedule',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Schedule'); return { Component }; },
	},
	{
		path: 'schedule/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Schedule'); return { Component }; },
	},
	{
		path: 'schedule/:athleteId/:workoutDate/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Schedule'); return { Component }; },
	},
	{
		path: 'athletegroups/',
		lazy: async () => { const { default: Component } = await import('../pages/protected/AthleteGroups'); return { Component }; },
	},
	{
		path: 'athletegroups/:groupId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleAthleteGroup'); return { Component }; },
	},
	{
		path: 'workout-library',
		lazy: async () => { const { default: Component } = await import('../pages/protected/WorkoutLibrary'); return { Component }; },
	},
	{
		path: 'workout-library/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/WorkoutLibrary'); return { Component }; },
	},
	{
		path: 'workout/:workoutId/input',
		lazy: async () => { const { default: Component } = await import('../pages/protected/WorkoutInput'); return { Component }; },
	},
	{
		path: 'exercise-library',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ExerciseLibrary'); return { Component }; },
	},
	{
		path: 'exercise-library/:exerciseId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ExerciseLibrary'); return { Component }; },
	},
	{
		path: 'completed-workouts',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CompletedWorkouts'); return { Component }; },
	},
	{
		path: 'completed-workouts/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CompletedWorkouts'); return { Component }; },
	},
	{
		path: 'completed-workouts/:athleteId/:completedWorkoutId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleCompletedWorkout'); return { Component }; },
	},
	{
		path: 'completed-workouts/:athleteId/:completedWorkoutId/:exerciseId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleCompletedExercise'); return { Component }; },
	},
	{
		path: 'chat',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Chat'); return { Component }; },
	},
	{
		path: 'chat/:chatId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Chat'); return { Component }; },
	},
	{
		path: 'group-chat/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ChatGroup'); return { Component }; },
	},
	{
		path: 'support/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Support'); return { Component }; },
	},
	{
		path: 'support',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Support'); return { Component }; },
	},
	{
		path: 'tickets',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Tickets'); return { Component }; },
	},
	{
		path: 'tickets/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleTicket'); return { Component }; },
	},
	{
		path: 'rapsodo-hitting',
		lazy: async () => { const { default: Component } = await import('../pages/protected/RapsodoHitting'); return { Component }; },
	},
	{
		path: 'rapsodo-hitting/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/RapsodoHittingAthlete'); return { Component }; },
	},
	{
		path: 'rapsodo',
		lazy: async () => { const { default: Component } = await import('../pages/protected/RapsodoData'); return { Component }; },
	},
	{
		path: 'rapsodo/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/RapsodoSingle'); return { Component }; },
	},
	{
		path: 'trackman',
		lazy: async () => { const { default: Component } = await import('../pages/protected/TrackmanData'); return { Component }; },
	},
	{
		path: 'trackman/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/TrackmanSingle'); return { Component }; },
	},
	{
		path: 'blastMotion',
		lazy: async () => { const { default: Component } = await import('../pages/protected/BlastMotionData'); return { Component }; },
	},
	{
		path: 'blastMotion/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/BlastMotionSingle'); return { Component }; },
	},
	{
		path: 'pitchLogic',
		lazy: async () => { const { default: Component } = await import('../pages/protected/PitchLogicData'); return { Component }; },
	},
	{
		path: 'pitchLogic/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/PitchLogicSingle'); return { Component }; },
	},
	{
		path: 'armcare',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ArmCareData'); return { Component }; },
	},
	{
		path: 'armcare/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ArmCareSingle'); return { Component }; },
	},
	{
		path: 'fileroom',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Fileroom'); return { Component }; },
	},
	{
		path: 'fileroom/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleFile'); return { Component }; },
	},
	{
		path: 'fileroom/:id/draw',
		lazy: async () => { const { default: Component } = await import('../pages/protected/fileroomDrawing'); return { Component }; },
	},
	{
		path: 'file-comparison',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FileComparison'); return { Component }; },
	},
	{
		path: 'admin-actions',
		lazy: async () => { const { default: Component } = await import('../pages/protected/AdminActions'); return { Component }; },
	},
	{
		path: '404',
		lazy: async () => { const { default: Component } = await import('../pages/protected/404'); return { Component }; },
	},
	{
		path: 'blank',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Blank'); return { Component }; },
	},
	{
		path: 'nutrition/:athleteId/input/:day',
		lazy: async () => { const { default: Component } = await import('../pages/protected/NutritionSingleDay'); return { Component }; },
	},
	{
		path: 'nutrition/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FoodJournalEntries'); return { Component }; },
	},
	{
		path: 'nutrition/:athleteId/:day/:entryId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FoodJournalSingleEntry'); return { Component }; },
	},
	{
		path: 'nutrition',
		lazy: async () => { const { default: Component } = await import('../pages/protected/FoodJournalEntries'); return { Component }; },
	},
	{
		path: 'command',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Command'); return { Component }; },
	},
	{
		path: 'command/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Command'); return { Component }; },
	},
	{
		path: 'command/:athleteId/input',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CommandInput'); return { Component }; },
	},
	{
		path: 'command/:athleteId/input/:sessionId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CommandInput'); return { Component }; },
	},
	{
		path: 'command/:athleteId/view/:sessionId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CommandSession'); return { Component }; },
	},
	{
		path: 'pocket-radar',
		lazy: async () => { const { default: Component } = await import('../pages/protected/PocketRadar'); return { Component }; },
	},
	{
		path: 'pocket-radar/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/PocketRadarAthlete'); return { Component }; },
	},
	{
		path: 'pocket-radar/:athleteId/input',
		lazy: async () => { const { default: Component } = await import('../pages/protected/PocketRadarInput'); return { Component }; },
	},
	{
		path: 'nextiles',
		lazy: async () => { const { default: Component } = await import('../pages/protected/NextilesSessions'); return { Component }; },
	},
	{
		path: 'nextiles/:athleteId/',
		lazy: async () => { const { default: Component } = await import('../pages/protected/NextilesSessions'); return { Component }; },
	},
	{
		path: 'nextiles/:athleteId/:sessionId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleNextilesSession'); return { Component }; },
	},
	{
		path: 'coaches-workbench',
		lazy: async () => { const { default: Component } = await import('../pages/protected/CoachesWorkbench'); return { Component }; },
	},
	{
		path: 'scheduleTemplates',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleTemplates'); return { Component }; },
	},
	{
		path: 'scheduleTemplates/:templateId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SingleScheduleTemplate'); return { Component }; },
	},
	{
		path: 'scheduleTemplates/:templateId/assign',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleTemplateAssigner'); return { Component }; },
	},
	{
		path: 'scheduleTemplates/:templateId/:workoutDate',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ScheduleTemplateWorkoutSelector'); return { Component }; },
	},
	{
		path: 'progressions',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Progressions'); return { Component }; },
	},
	{
		path: 'progressions/:progressionId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Progressions'); return { Component }; },
	},
	{
		path: 'activities',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Activities'); return { Component }; },
	},
	{
		path: 'subscriptions',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Subscriptions'); return { Component }; },
	},
	{
		path: 'subscriptions/:id',
		lazy: async () => { const { default: Component } = await import('../pages/protected/Subscriptions'); return { Component }; },
	},
	{
		path: 'subscriptions/:planId/checkout',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SubscriptionCheckout'); return { Component }; },
	},
	{
		path: 'subscriptions/:planId/checkout/:status',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SubscriptionCheckout'); return { Component }; },
	},
	{
		path: 'subscriptions/:planId/edit',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SubscriptionCheckout'); return { Component }; },
	},
	{
		path: 'subscriptions/:planId/overview/:athleteId',
		lazy: async () => { const { default: Component } = await import('../pages/protected/SubscriptionOverview'); return { Component }; },
	},
	{
		path: 'management/athlete-schedules',
		lazy: async () => { const { default: Component } = await import('../pages/protected/ManagementAthleteSchedules'); return { Component }; },
	},
];

export default routes;
